import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
// Migrated 1:1 from @nexato/nx-core-module (issue/components/updateLocation/update-issue-location-widget.component.ts, #683)
import { EditSelectable, EditSelectInputComponent } from '../../edit-select-form-control/edit-select-form-control.component';
import { CommandService } from '../../../services/command/command.service';
import { CommandInput, CommandTemplate } from '../../../entities/commandTemplate/commandTemplate';
import { IssueWidget } from '../../../services/issue/issue-widget.interface';
import { WidgetCoordinatorService } from '../../../services/issue/widget-coordinator.service';
import { RefetchCoordinator } from '../../../services/refetch-coordinator/refetch-coordinator.service';
import { LocationService } from '../../../services/location/location.service';
import { HasLocation } from '../../../entities/issue/issue';
import { Location as LocationEntity } from '../../../entities/location/location';

@Component({
  selector: 'nx-update-issue-location-widget',
  templateUrl: './update-issue-location-widget.component.html',
})
export class UpdateIssueLocationWidgetComponent implements OnDestroy, OnInit, OnChanges, IssueWidget {

  @Input() hasLocation: HasLocation;
  @ViewChild('selectComponent') selectComponent: EditSelectInputComponent;
  public placeholder = "Niederlassung auswählen"

  public editMode: boolean = false;
  public isLoading: boolean = false;

  public commandTemplate: CommandTemplate;

  public activeLocation: LocationEntity | null = null;

  public allLocations: LocationEntity[];

  options: EditSelectable[] = [];
  selectedControl = new FormControl<string | null>(null);
  form = new FormGroup({
    selected: this.selectedControl
  });

  private widgetId = `location-widget-${Math.random().toString(36).substr(2, 9)}`;
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private refetchCoordinator = inject(RefetchCoordinator);
  private locationService = inject(LocationService);
  private unregisterRefetch?: () => void;

  constructor(
    private commandService: CommandService,
    private coordinator: WidgetCoordinatorService
  ) {
  }


  ngOnInit(): void {
    // Register with RefetchCoordinator as detail view
    if (this.hasLocation?.getEntityId()) {
      this.unregisterRefetch = this.refetchCoordinator.register(
        this,
        this.hasLocation.getEntityType(),
        this.hasLocation.getEntityId()
      );
    }

    // Subscribe to cancel all requests
    this.coordinator.cancelAll$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(exceptId => {
        if (exceptId !== this.widgetId) {
          this.cancel();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hasLocation'] && this.hasLocation && this.hasLocation.getEntityId) {
      this.loadCommandTemplate();
    }
  }

  loadCommandTemplate() {
    // TODO: Replace with actual command once backend is implemented
    const commandInput = new CommandInput();
    commandInput.name = "issueUpdateLocationCommand"; // Dummy command name
    commandInput.addParameter('commandProviderId', this.hasLocation.getEntityId());

    // Load all locations
    // this.locationService.getLocations()
    //   .pipe(take(1))
    //   .subscribe(locations => {
    //     this.allLocations = locations;
    //     this.options = locations;

    //     // TODO: Load active location from backend once implemented
    //     // For now, set to null (no location selected)
    //     this.activeLocation = null;
    //     this.selectedControl.patchValue(this.activeLocation);

    //     this.isLoading = false;
    //     this.cdr.detectChanges();
    //   });

    // TODO: Uncomment once backend command is implemented
    this.commandService.getCommandByCommandInput(commandInput)
        .pipe(take(1))
        .subscribe(result => {
          this.allLocations = LocationEntity.createLocations(result?.data?.getCommandByCommandInput?.flow?.settings?.customFlowSettings?.locations);
          this.activeLocation = result?.data?.getCommandByCommandInput?.flow?.settings?.customFlowSettings?.location
            ? new LocationEntity(result.data.getCommandByCommandInput.flow.settings.customFlowSettings.location)
            : null;
          this.options = this.allLocations;
          this.selectedControl.patchValue(this.activeLocation?.id ?? null);
          this.commandTemplate = result.data.getCommandByCommandInput;
          this.isLoading = false;
          this.cdr.detectChanges();
        });
  }

  ngOnDestroy(): void {
    this.unregisterRefetch?.();
  }

  edit() {
    this.coordinator.requestCancelAll(this.widgetId);
    this.editMode = true;
  }

  save() {
    console.log('Saving location update...');
    this.editMode = false;
    let selectedId = this.selectedControl.value;

    // TODO: Replace with actual command once backend is implemented
    let commandInput = new CommandInput();
    commandInput.name = "issueUpdateLocationCommand"; // Dummy command name
    commandInput.addParameter('commandProviderId', this.hasLocation.getEntityId());
    commandInput.addParameter('locationId', selectedId);

    this.isLoading = true;

    // TODO: Uncomment once backend command is implemented
    this.commandService.sendCommand(commandInput, (result) => {
      this.loadCommandTemplate();
      this.refetchCoordinator.emit({ entityType: this.hasLocation.getEntityType(), entityId: this.hasLocation.getEntityId() });
    });

  }

  cancel() {
    this.editMode = false;
    this.selectedControl.patchValue(this.activeLocation?.id ?? null);
  }

  onFilter = (filterValue: string) => {
    console.log('Remote filter triggered with value:', filterValue);
  };

  reload(): void {
    this.loadCommandTemplate();
  }
}
